import { get } from 'lodash'

import { Container, getTranslatedString } from '@skinsoft/types'

export const futureLocation = (container: Container, locale: string) =>
    getTranslatedString(
        get(container, 'locationItemSchema.futureLocation.futureLocation.path'),
        locale,
    )

export const location = (container: Container, locale: string) => {
    return getTranslatedString(get(container, 'locationItemSchema.realTimeLocation.realTimeLocation.path'), locale) 
    || get(container, 'locationItemSchema.realTimeLocation.realTimeLocation')
}

export const typeOfContent = (container: Container) => get(container, 'containerItemDataSchema.typeOfContent')

export const itemType = (container: Container) => get(container, 'descriptionItemSchema.itemType')
